<template>
  <div>
    <el-dialog
      ref="addEditDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="add_view_edit_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        element-loading-text="努力加载数据中，请耐心等待"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogAddEditForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogAddEditForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="付款单位"
                    prop="payerId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.payerId"
                      filterable
                      clearable
                      placeholder="请选择付款单位"
                      style="width:100%"
                      @change="payerChangeFun"
                    >
                      <el-option
                        v-for="item in payerOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                        <span style="float: left">{{ item.label }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.areaInfo }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="付款方式"
                    required
                  >
                    <el-radio-group v-model="dialogAddEditForm.payMethod">
                      <el-radio :label="1">
                        对公转账
                      </el-radio>
                      <el-radio :label="3">
                        个人垫付
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="付款日期"
                    prop="payDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditForm.payDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="支付渠道"
                    required
                  >
                    <el-radio-group v-model="dialogAddEditForm.payChannel">
                      <el-radio :label="1">
                        网银
                      </el-radio>
                      <el-radio :label="4">
                        现金
                      </el-radio>
                      <el-radio :label="2">
                        微信
                      </el-radio>
                      <el-radio :label="3">
                        支付宝
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="付款银行"
                    prop="payBankName"
                  >
                    <el-input
                      v-model="dialogAddEditForm.payBankName"
                      maxlength="128"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="付款账号"
                    prop="payBankNo"
                  >
                    <el-input
                      v-model="dialogAddEditForm.payBankNo"
                      maxlength="64"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="付款金额">
                    <el-input
                      v-model="mathPaidTotal"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="收款单位">
                    <el-input
                      v-model="dialogAddEditForm.unitName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收款银行名称">
                    <el-input
                      v-model="dialogAddEditForm.unitBankName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收款银行账号">
                    <el-input
                      v-model="dialogAddEditForm.unitBankNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              明细信息
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="dialogAddEditForm.paidDetailData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                      align="center"
                    />
                    <el-table-column
                      label="科目"
                      prop="paymentSubjectValue"
                      width="100"
                      align="center"
                    />
                    <el-table-column
                      label="项目名称"
                      prop="projectName"
                      header-align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span
                          class="link"
                          @click="showPayablePage(scope.row)"
                        >
                          {{ scope.row.projectName }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="项目日期"
                      prop="projectDateValue"
                      width="100"
                      align="center"
                    />
                    <el-table-column
                      label="业务区域"
                      prop="businessProvinces"
                      width="160"
                      align="center"
                      show-overflow-tooltip
                    />
                    <el-table-column
                      label="应付金额"
                      prop="payableAmount"
                      width="100"
                      align="center"
                    />
                    <el-table-column
                      label="未付金额"
                      prop="leftAmount"
                      width="100"
                      align="center"
                    />
                    <el-table-column
                      label="付款金额"
                      width="150"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'paidDetailData.' + scope.$index + '.amount'"
                          :rules="dialogAddEditFormRules.amount"
                        >
                          <el-input
                            v-model="scope.row.amount"
                            @input="(val)=>{limitPositiveNumber(val, scope.row, 'amount')}"
                            @blur="setNumberValueDefaultZero($event, scope.row, 'amount', 2);"
                          />
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box pic-container">
            <h3 class="modal-title">
              附件信息
            </h3>
            <div class="modal-row-box">
              <el-upload
                ref="picUpload"
                list-type="picture-card"
                :action="picUploadAction"
                :data="picData"
                :before-upload="beforeAvatarUpload"
                :file-list="initFileList"
                :on-preview="handlePictureCardPreview"
                :headers="{'X-Token': getToken()}"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
                :with-credentials="true"
                :on-success="function (res, file, fileList) {return handleSuccess (res, file, fileList, picList)}"
                :on-remove="(file,fileList)=>handlePictureCardRemove(file,fileList,picList)"
              >
                <el-button
                  type="success"
                  style="margin-top:1px; margin-right:15px;"
                  class="upload-button"
                  icon="el-icon-folder-opened"
                >
                  选择图片
                </el-button>
              </el-upload>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditForm.remark"
                      type="textarea"
                      placeholder="备注"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          :disabled="operateButtonDisable"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
      <!--图片预览-->
      <el-dialog
        :visible.sync="dialogImageVisible"
        append-to-body
      >
        <img
          width="100%"
          :src="dialogImageUrl"
          alt=""
        >
      </el-dialog>
      <!-- 查看应付单 -->
      <view-dialog
        :data-id="payableId"
        :event-type="'view'"
        :dialog-title="'查看应付款单'"
        :dialog-visible.sync="dialogPayableViewVisible"
      />
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 查看应付单
import viewDialog from '@/views/fundsModule/payableBill/components/viewDialog'
// 数据请求
import { getToken } from "@/utils/auth"
import { initPaymentVoucherApi, saveOrUpdatePaymentVoucherApi } from '@/api/paymentVoucher'
import { loadPayerSelectDataApi } from '@/api/payerSetting'
// 附件
import { deleteFileApi } from '@/api/common'

export default {
  components: {viewDialog},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    },
    dataArray: {
      type: Array,
      default: () => []
    }
  },
  data() {
    // 付款金额
    const validatePaidAmount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入付款金额'))
      } else if (Number(value) === 0) {
        callback(new Error('付款金额不能为0'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      operateButtonDisable: false,

      dialogAddEditForm: {
        paidDetailData: []
      },
      dialogAddEditFormRules: {
        payBankName: [{ required: false, message: '请输入付款银行名称', trigger: 'blur' }, { max: 128, message: '最多输入256个字符', trigger: 'blur' }],
        payBankNo: [{ required: false, message: '请选择付款账户信息', trigger: 'blur' }, { max: 32, message: '最多输入32个字符', trigger: 'blur' }],
        payDate: [{ required: true, message: '请选择付款日期', trigger: 'blur' }],
        amount: [{ required: true, validator: validatePaidAmount, trigger: ['blur', 'change'] }],
        remark: [{ max: 250, message: '最多输入250个字符', trigger: 'blur' }]
      },
      payerOptions: [],
      //附件相关
      picData: { directory: 'paymentVoucher', sort: 999 },
      picUploadAction: '',
      initFileList: [],
      dialogImageUrl: '',
      dialogImageVisible: false,
      picList: [], // 照片对象数组
      baseUrl: '',
      payableId: 0,
      dialogPayableViewVisible: false
    }
  },
  computed: {
    // 计算付款总金额
    mathPaidTotal() {
      return this.dialogAddEditForm.paidDetailData.reduce((prev, item) => {
        return this.roundNumber(prev + Number(item.amount), 2)
      }, 0)
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.loading = true
        this.operateButtonDisable = false

        this.dialogAddEditForm = {
          provinceId: 0,
          provinceName: '',
          cityId: 0,
          cityName: '',
          payerId: '',
          payerName: '',
          projectNames: '',
          payMethod: 0,
          payMethodValue: '',
          payChannel: 0,
          payBankName: '',
          payBankNo: '',
          unitId: 0,
          unitName: '',
          unitBankName: '',
          unitBankNo: '',
          payDate: '',
          voucherNo: '',
          payAmount: 0,
          isReimburse: 0,
          remark: '',
          paymentHandler: 0,
          paidDetailDataJson: '',
          paidDetailData: []
        }
        //附件相关
        this.baseUrl = process.env.VUE_APP_BASE_API
        this.picUploadAction = process.env.VUE_APP_BASE_API + '/web/common/uploadFile'
        this.picList = []
        this.initFileList = []

        // 获取付款方数据
        this.initPayerData()
        if (this.eventType === 'edit') {
          this.initEditData()
        } else {
          this.initAddData()
        }

        this.$nextTick(() => {
          this.$refs.dialogAddEditForm.clearValidate()
        })
      }
    }
  },
  methods: {
    getToken,
    //新增
    initAddData() {
      let projectNames = ''
      this.dataArray.forEach(item => {
        this.dialogAddEditForm.unitId = item.unitId
        this.dialogAddEditForm.unitName = item.unitName
        this.dialogAddEditForm.unitBankName = item.unitBankName
        this.dialogAddEditForm.unitBankNo = item.unitBankNo
        //清除字符串中的空格并每4位插入空格符
        this.dialogAddEditForm.unitBankNo = this.dialogAddEditForm.unitBankNo.replace(/\s+/g, '')
        this.dialogAddEditForm.unitBankNo = this.dialogAddEditForm.unitBankNo.replace(/(.{4})/g, '$1 ').trim()

        this.dialogAddEditForm.paymentHandler = item.paymentHandler
        this.dialogAddEditForm.payMethod = item.payMethod
        this.dialogAddEditForm.payMethodValue = item.payMethodValue
        projectNames += ',' + item.projectName

        this.dialogAddEditForm.paidDetailData.push({
          payableId: item.id,
          paymentSubjectValue: item.paymentSubjectValue,
          projectName: item.projectName,
          projectDateValue: item.projectDateValue,
          projectSort: item.projectSort,
          businessProvinces: item.businessProvinces,
          payableAmount: item.payableAmount,
          leftAmount: item.leftAmount,
          amount: item.leftAmount
        })
      })
      this.dialogAddEditForm.projectNames = projectNames.substring(1)
      if (this.dialogAddEditForm.payMethod === 1) {
        this.dialogAddEditForm.isReimburse = 2
        this.dialogAddEditForm.payChannel = 1
      } else {
        this.dialogAddEditForm.isReimburse = 0
        this.dialogAddEditForm.payChannel = 4
      }
      this.loading = false
    },
    // 加载数据
    initEditData() {
      initPaymentVoucherApi({ id: this.dataId }).then(res => {
        const { paymentVoucher, payablePayments, fileList } = res.data

        for (let key in this.dialogAddEditForm) {
          if (!paymentVoucher[key]) continue
          this.dialogAddEditForm[key] = paymentVoucher[key]
        }

        this.dialogAddEditForm.payDate = paymentVoucher.payDateValue
        this.dialogAddEditForm.id = paymentVoucher.id
        //清除字符串中的空格并每4位插入空格符
        this.dialogAddEditForm.unitBankNo = this.dialogAddEditForm.unitBankNo.replace(/\s+/g, '')
        this.dialogAddEditForm.unitBankNo = this.dialogAddEditForm.unitBankNo.replace(/(.{4})/g, '$1 ').trim()
        if (payablePayments) {
          this.dialogAddEditForm.paidDetailData = []
          payablePayments.forEach(item => {
            item.leftAmount = Number((Number(item.leftAmount) + Number(item.amount)).toFixed(2))
            this.dialogAddEditForm.paidDetailData.push(item)
          })
        }

        //附件相关
        if (fileList.length > 0) {
          fileList.forEach(item => {
            let obj = {
              name: item.attachmentName,
              url: this.baseUrl + item.attachmentUrl,
              attachmentName: item.attachmentName,
              attachmentUrl: item.attachmentUrl
            }
            this.picList.push(obj)
            this.initFileList.push(obj)
          })
        }
        this.loading = false
      })
    },
    // 获取付款方选项数据
    initPayerData() {
      this.payerOptions = []
      loadPayerSelectDataApi({ orderSort: 'province_id, city_id, name asc' }).then(response => {
        response.data.forEach(item => {
          this.payerOptions.push({
            label: item.name, value: item.id,
            provinceId: item.provinceId, provinceName: item.provinceName,
            cityId: item.cityId, cityName: item.cityName,
            bankName: item.bankName, bankNo: item.bankNo,
            areaInfo: item.provinceName + ' - ' + item.cityName
          })
        })
      })
    },
    // 付款方选择回调方法
    payerChangeFun(val) {
      let selectItem = {}
      selectItem = this.payerOptions.find(item => {
        return item.value === val
      })
      this.dialogAddEditForm.payerName = selectItem.label || ''
      this.dialogAddEditForm.provinceId = selectItem.provinceId || 0
      this.dialogAddEditForm.provinceName = selectItem.provinceName || ''
      this.dialogAddEditForm.cityId = selectItem.cityId || 0
      this.dialogAddEditForm.cityName = selectItem.cityName || ''
      this.dialogAddEditForm.payBankName = selectItem.bankName || ''
      this.dialogAddEditForm.payBankNo = selectItem.bankNo || ''
    },
    //上传前
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 20
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过20MB!')
        return false
      }
      this.isUploading = true
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    // 上传成功
    handleSuccess(res, file, fileList, dataObj) {
      if (res.mark === '200') {
        let fileObj = {}
        fileObj.attachmentName = res.myFileName
        fileObj.attachmentUrl = res.fileName
        fileObj.url = this.baseUrl + res.fileName
        dataObj.push(fileObj)
        this.isUploading = false
      } else {
        this.$message.error(res.message)
      }
    },
    // 删除
    handlePictureCardRemove(file, fileList, dataObj) {
      let fileUrl = ''
      if (file.response) {
        let resData = file.response
        let delIndex = dataObj.findIndex(item => {
          return item.attachmentUrl === resData.fileName
        })
        fileUrl = resData.fileName
        dataObj.splice(delIndex, 1)
      } else {
        let delIndex = dataObj.findIndex(item => {
          if (item.url === file.url) {
            fileUrl = item.attachmentUrl
            return item.url === file.url
          }
        })
        dataObj.splice(delIndex, 1)
      }
      if (fileUrl !== '') {
        deleteFileApi({ filePath: fileUrl }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
          }
        })
      }
    },
    // 显示应付单
    showPayablePage(data){
      this.payableId = data.payableId
      this.dialogPayableViewVisible = true
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    // 关闭弹框
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.dialogAddEditForm.paidDetailData.forEach(item => {
        if (Number(item.amount) > Number(item.leftAmount)) {
          this.$message({ message: '项目(' + item.projectName + ')付款金额大于未付款金额，不能保存', type: 'warning' })
          return false
        }
      })
      if (this.dialogAddEditForm.provinceName === null || this.dialogAddEditForm.provinceName === '') {
        this.$message({ message: '无区域信息，不能处理数据', type: 'warning' })
        return false
      }
      this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '付款单', '系统提示',
            { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          ).then(async () => {
            this.loading = true
            this.operateButtonDisable = true

            this.dialogAddEditForm.payAmount = Number(this.mathPaidTotal)
            this.dialogAddEditForm.paidDetailDataJson = JSON.stringify(this.dialogAddEditForm.paidDetailData)

            //附件相关
            let picUrls = []
            let picNames = []
            this.picList.forEach(item => {
              picUrls.push(item.attachmentUrl)
              picNames.push(item.attachmentName)
            })
            this.dialogAddEditForm.picUrls = JSON.stringify(picUrls)
            this.dialogAddEditForm.picNames = JSON.stringify(picNames)
            saveOrUpdatePaymentVoucherApi(this.dialogAddEditForm).then(res => {
              if (res.mark === '200') {
                this.$message({ message: res.message, type: 'success' })
                this.reloadData()
                this.modalClose()
              }
            }).catch(() => {
              this.loading = false
              this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    },
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
::v-deep .special-row .el-col {
  min-height: 20px;
}
.pic-container {
  position: relative;
  .pic-name {
    display: inline-block;
    padding-top: 7px;
    margin-bottom: 10px;
  }
  .upload-button {
    position: absolute;
    top: 0;
    right: 0px;
  }
  ::v-deep .el-upload--picture-card i {
    font-size: 14px !important;
    color: #fff !important;
  }
  ::v-deep .el-upload--picture-card {
    border: none;
    height: 0px;
    overflow: hidden;
  }
}
::v-deep .el-upload-list--picture-card {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .el-upload-list__item {
    display: flex;
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    align-items: center;
    border-radius: 0;
  }
  .el-upload-list__item-thumbnail {
    height: auto;
    align-items: center;
  }
}
::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}
.demo-input-suffix {
  padding: 10px 0;
  .el-input {
    margin-right: 10px;
    width: 120px;
  }
  .title-sp {
    color: #1a9bff;
    margin-right: 10px;
  }
}
.link {
  color: #5867dd;
  cursor: pointer;
}
.link:hover {
  text-decoration: underline;
}
</style>
